import { BidBattleImageWrapper, BidBattleStatus } from "@/components/battle";
import { seo } from "@/lib/seo";
import { m } from "@/paraglide/messages";
import {
	Carousel,
	CarouselContent,
	CarouselIndicators,
	CarouselItem,
	CarouselNext,
	CarouselPrevious,
	EmblaHorizontalScrollPlugin,
} from "@bidbattles/bloks/components/ui/carousel";
import { BBBackendQueryOptions } from "@bidbattles/bloks/lib/rapace";
import { useSuspenseQuery } from "@tanstack/react-query";
import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/battle/$id")({
	component: RouteComponent,
	beforeLoad({ location, params: { id } }) {
		// TODO: Cleaner/better way to do this?
		if (
			location.pathname === `/battle/${id}` ||
			location.pathname === `/battle/${id}/`
		) {
			throw redirect({ to: "/battle/$id/details", params: { id } });
		}
	},
	async loader({ params, context }) {
		const battle = await context.queryClient.ensureQueryData(
			BBBackendQueryOptions.fetchBattle({ id: params.id }),
		);
		return { battle };
	},
	head: ({ loaderData: { battle } = {} }) => ({
		meta: [
			...seo({
				title: `${battle?.item_name} | ${m.bidbattles()}`,
				description: battle?.item_description,
			}),
		],
	}),
});

function RouteComponent() {
	const { id } = Route.useParams();
	const query = useSuspenseQuery(BBBackendQueryOptions.fetchBattle({ id }));
	const battle = query.data;
	return (
		<section className="w-full flex flex-col items-center py-box">
			<div className="max-w-container lg:grid grid-cols-12 lg:ps-box w-full">
				<div className="flex flex-col col-span-7">
					<Carousel
						className="overflow-hidden lg:rounded-lg"
						plugins={[EmblaHorizontalScrollPlugin]}
					>
						<CarouselContent>
							{battle.item_image_urls.map((url) => (
								<CarouselItem key={url} flush>
									<BidBattleImageWrapper>
										<img
											src={url}
											alt={battle.item_name}
											className="w-full object-contain lg:aspect-[1.15/1]"
											loading="lazy"
										/>
									</BidBattleImageWrapper>
								</CarouselItem>
							))}
						</CarouselContent>
						<BidBattleStatus status={battle.status} />
						<CarouselIndicators className="absolute bottom-8 start-1/2 -translate-x-1/2" />
					</Carousel>
					<div className="px-box lg:px-0 py-box">
						<h1 className="mb-2.5 font-bold text-lg leading-7 lg:text-3xl lg:leading-[2.375rem]">
							{battle.item_name}
						</h1>
						<p className="whitespace-pre-line">{battle.item_description}</p>
					</div>
				</div>
				<Outlet />
			</div>
		</section>
	);
}
